export default __webpack_public_path__ + "8b2b11b18d6e548dca5c3275dc4cfc07.svg";